import { render, staticRenderFns } from "./RejectableComplaint.vue?vue&type=template&id=7c723fd9&scoped=true&"
import script from "./RejectableComplaint.vue?vue&type=script&lang=js&"
export * from "./RejectableComplaint.vue?vue&type=script&lang=js&"
import style0 from "./RejectableComplaint.vue?vue&type=style&index=0&id=7c723fd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c723fd9",
  null
  
)

export default component.exports